import { saveAs } from 'file-saver';

// Frontend now just calls the server endpoints
export const exportDataToCSV = async () => {
  // Show loading indicator (keep existing UI style)
  const loadingToast = document.createElement('div');
  loadingToast.className = 'fixed top-4 right-4 bg-primary-600 text-white px-4 py-2 rounded-lg shadow-lg z-50';
  loadingToast.textContent = 'Requesting backup from server...';
  document.body.appendChild(loadingToast);

  try {
    const res = await fetch('/api/backup', {
      method: 'GET',
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    const blob = await res.blob();
    const fileName = res.headers.get('Content-Disposition')?.match(/filename="(.+)"/)?.[1] ||
      `bpa_complete_backup_${new Date().toISOString().split('T')[0]}.csv`;

    saveAs(blob, fileName);

    document.body.removeChild(loadingToast);
    const successToast = document.createElement('div');
    successToast.className = 'fixed top-4 right-4 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg z-50';
    successToast.innerHTML = `
      <div>
        <div class="font-medium">Complete backup downloaded successfully!</div>
        <div class="text-sm mt-1">Your data has been safely exported from the server.</div>
      </div>
    `;
    document.body.appendChild(successToast);
    setTimeout(() => {
      if (document.body.contains(successToast)) {
        document.body.removeChild(successToast);
      }
    }, 5000);

  } catch (error) {
    console.error('Error requesting backup:', error);
    if (document.body.contains(loadingToast)) {
      document.body.removeChild(loadingToast);
    }
    const errorToast = document.createElement('div');
    errorToast.className = 'fixed top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-lg shadow-lg z-50 max-w-sm';
    errorToast.innerHTML = `
      <div>
        <div class="font-medium">Backup creation failed</div>
        <div class="text-sm mt-1">${error.message || 'Unknown error occurred'}</div>
        <div class="text-xs mt-2">Please check your connection and try again.</div>
      </div>
    `;
    document.body.appendChild(errorToast);
    setTimeout(() => {
      if (document.body.contains(errorToast)) {
        document.body.removeChild(errorToast);
      }
    }, 8000);
    throw error;
  }
};

export const importDataFromCSV = async (file) => {
  const loadingToast = document.createElement('div');
  loadingToast.className = 'fixed top-4 right-4 bg-primary-600 text-white px-4 py-2 rounded-lg shadow-lg z-50';
  loadingToast.textContent = 'Uploading backup to server...';
  document.body.appendChild(loadingToast);

  try {
    const formData = new FormData();
    formData.append('file', file);

    const res = await fetch('/api/restore', {
      method: 'POST',
      body: formData,
    });

    let json;
    try {
      json = await res.json();
    } catch (e) {
      // If parsing fails, use text or status details
      const text = await res.text();
      throw new Error(text || `Request failed with status ${res.status}`);
    }

    if (!res.ok || !json.success) {
      // If we have specific error details (from our new backend logic), use them
      const msg = json.message || 'Restore failed';
      throw new Error(msg);
    }

    document.body.removeChild(loadingToast);
    const successToast = document.createElement('div');
    successToast.className = 'fixed top-4 right-4 bg-green-600 text-white px-4 py-2 rounded-lg shadow-lg z-50';
    successToast.innerHTML = `
      <div>
        <div class="font-medium">Backup restored successfully!</div>
        <div class="text-sm mt-1">
          ✓ ${json.counts?.members ?? 0} members<br>
          ✓ ${json.counts?.notes ?? 0} session notes<br>
          ✓ ${json.counts?.strategic_goals ?? 0} strategic goals<br>
          ✓ ${json.counts?.mini_goals ?? 0} mini-goals<br>
          ✓ ${json.counts?.coaches ?? 0} coaches
        </div>
      </div>
    `;
    document.body.appendChild(successToast);
    setTimeout(() => {
      if (document.body.contains(successToast)) {
        document.body.removeChild(successToast);
      }
    }, 5000);

  } catch (error) {
    console.error('Error restoring backup:', error);
    if (document.body.contains(loadingToast)) {
      document.body.removeChild(loadingToast);
    }
    const errorToast = document.createElement('div');
    errorToast.className = 'fixed top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-lg shadow-lg z-50 max-w-sm';
    errorToast.innerHTML = `
      <div>
        <div class="font-medium">Restore failed</div>
        <div class="text-sm mt-1">${error.message || 'Unknown error occurred'}</div>
        <div class="text-xs mt-2">Check the console for detailed error logs.</div>
      </div>
    `;
    document.body.appendChild(errorToast);
    setTimeout(() => {
      if (document.body.contains(errorToast)) {
        document.body.removeChild(errorToast);
      }
    }, 8000);
    throw error;
  }
};